/**
 * roleLanding — where someone lands on `/` when they have not picked a start
 * page (Settings › Default landing page, or "Make this my start page" on My
 * Tasks — both write users/{uid}.defaultView, which wins over this).
 *
 * RW-2902: a TC's role default is what it was before the one task inbox
 * changed it — /my-tasks (the rail's "Other Tasks"). That route rides the
 * `myTasks` flag, and the route guard in App.js sends a page whose flag is off
 * to /dashboard ("This feature is not available yet."). So with `myTasks` off
 * (prod) a TC always ended on the Dashboard, by way of that bounce; here they go
 * straight there instead, with no toast. With it on they land on /my-tasks.
 * The guard's own question (isPathEnabled) decides, so until the flags have
 * loaded a TC has no answer yet (null — the caller waits) rather than a guess
 * the guard would then bounce. A TC who wants the inbox makes it their start
 * page in one click (StartPageControl on My Tasks).
 */
import { isPathEnabled } from './featureFlags';

/** My Tasks, the one task inbox — the nav badge and Home read it only when it is open. */
export const TASK_INBOX_PATH = '/deals/tasks';
const OTHER_TASKS_PATH = '/my-tasks';
// Where App.js's route guard sends a page whose flag is off.
const GUARD_FALLBACK_PATH = '/dashboard';

export function defaultLandingFor(role, { flags = null, flagsLoaded = false } = {}) {
  switch (role) {
    case 'trainer': return '/training';
    case 'tc':
      if (!flagsLoaded) return null;
      return isPathEnabled(OTHER_TASKS_PATH, flags, false) ? OTHER_TASKS_PATH : GUARD_FALLBACK_PATH;
    case 'admin':
    case 'super_admin': return '/dashboard';
    case 'agent':
    default: return '/feed';
  }
}
